export default "__VITE_ASSET__8SvPJm58__"